import React, { useEffect, useState } from 'react';
import app from '@app/auth/firebase';
import { UserInfo as UserInfoType } from '@app/types';
import { useGetUserQuery } from '@app/graphql';
import { Icon } from '@app/components';

type AuthContextType = {
  userInfo: UserInfoType | null;
  setUserInfo?: any;
};

type Props = {
  children: any;
};

const Loader = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: 'calc(100vh)',
  position: 'absolute' as 'absolute',
};

export const AuthContext = React.createContext<AuthContextType>({
  userInfo: null,
});

export function AuthProvider({ children }: Props) {
  const [isLoading, setIsLoading] = useState(true);
  const [userInfo, setUserInfo] = useState<UserInfoType | null>(null);
  const [userId, setUserId] = useState<string>('');
  const value = { userInfo, setUserInfo };
  const { loading, data } = useGetUserQuery({ firebaseId: userId });
  const emailVerification = data && data.user && data.user.emailVerification;
  const emailVerified = emailVerification && emailVerification.completed;

  useEffect(() => {
    app.auth().onAuthStateChanged(function(user: any) {
      if (user) {
        setUserId(user.uid);
        setUserInfo({
          id: user.uid,
          firebaseId: user.uid,
          firstName: user.displayName!
            ? user.displayName!.split(' ')[0]
            : user.firstName || '',
          lastName: user.displayName!
            ? user.displayName!.split(' ')[1]
            : user.lastName || '',
          displayName: user.displayName! || '',
          email: user.email!,
          phone: user.phoneNumber!,
          company: user.company!,
          profilePicUrl: user.photoURL!,
          emailVerification: {
            completed: user.emailVerified === true ? true : emailVerified,
          },
        });
      } else {
        setUserInfo(null);
        setIsLoading(false);
        setUserId('');
      }
    });
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (data && data.user && userInfo) {
      setUserInfo({
        ...userInfo,
        emailVerification: {
          completed: emailVerified,
        },
        source: data.user.source,
        userType: data.user.userType,
      });
      setIsLoading(false);
    }

    //eslint-disable-next-line
  }, [data, emailVerified]);

  if (isLoading || loading) {
    return (
      <div style={Loader}>
        <Icon name="loader" />
      </div>
    );
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
